module.exports = __webpack_public_path__ + "static/img/logo.82b9c7a.png";


//////////////////
// WEBPACK FOOTER
// ./build/logo.png
// module id = uCTF
// module chunks = 136